import { render, staticRenderFns } from "./remarksRisk.vue?vue&type=template&id=6890c978&"
import script from "./remarksRisk.vue?vue&type=script&lang=js&"
export * from "./remarksRisk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports